$(document).ready(function () {
  if ($('.archive-filters').length) {
    var opitons = {
      itemSelectText: '',
      removeItemButton: true,
    };
    var productElement = document.getElementById('product');
    var audienceElement = document.getElementById('audience');
    var topicElement = document.getElementById('topic');
    new Choices(productElement, opitons);
    new Choices(audienceElement, opitons);
    new Choices(topicElement, opitons);
    productElement.addEventListener('change', function (e) {
      searchWorker.product($(event.target).val());
    });
    audienceElement.addEventListener('change', function (e) {
      searchWorker.audience($(event.target).val());
    });
    topicElement.addEventListener('change', function (e) {
      searchWorker.topic($(event.target).val());
    });
    $('#search-filter').on('keyup', function () {
      searchWorker.search($(this).val());
    });
    $(window).on('scroll', function () {
      if ($(window).scrollTop() >= $('.archive-filters').offset().top - ($('.header-top').length ? $('.header-top').height() : 0)) {
        $('.archive-filters').addClass('sticky');
      } else {
        $('.archive-filters').removeClass('sticky');
      }
    }).trigger('scroll');
  }
});